export default __webpack_public_path__ + "3fcaaa7ae9ed0e3350256e76b4e13e40.png";